module.exports = __webpack_public_path__ + "img/house.d56626f5.jpg";